import React from 'react'
import FancyBox from './FancyBox'
import "animate.css"
import ZoomOut from './ZoomOut'

import { useState } from 'react'

import { Tooltip } from 'react-tooltip'

function PortfolioCard({ data, selectedCategory }) {
    const [imageError, setImageError] = useState(false);
    const att = 'https://parceirando.s3.amazonaws.com/media/landing/404.webp';
    return (
        <ZoomOut category={selectedCategory} data={data} className='col-lg-6 mix graphics templates ' >
            <div className="br-project-box">
                <h3>{data.title.substring(0, 30)}</h3>
                <div className="links">
                    <a target='_blank' href={data.url} rel='noreferrer'>{data.link?.hreflink1}</a> |
                    <a target='_blank' href={data.url} rel='noreferrer'>{data.Type}</a>
                </div>
                <Tooltip id="tooltip" style={{ backgroundColor: 'black', color: 'white', wordWrap: 'break-word', width: '300px', textAlign: 'center' }} />
                <p data-tooltip-id="tooltip" data-tooltip-content={data.description}>{data.description.substring(0, 50)} ...
                    <a target='_blank' href={data.url} rel='noreferrer'>Veja mais</a>
                </p>

                <div className="br-info" >
                    <img style={{ display: 'none' }} alt={data.title} src={data.image} onError={(e) => setImageError(true)} />
                    <div className="portfolio-img">
                        <a data-fancybox="gallery"
                            data-caption={data.title}
                            data-src={imageError ? att : data.image}
                            href={imageError ? att : data.image}
                            style={{ backgroundImage: `url(${imageError ? att : data.image})` }} >
                            <span className="overlay">+</span>
                        </a>
                        <FancyBox />
                    </div>

                    <div className="br-detail" >
                        <ul>

                            <li>Comissionado</li>
                            {/* <li>Data : {data.date}</li> */}
                            <li>-----------</li>
                            <li>Cliente : {data.client.substring(0, 20)}</li>
                            {/* <li>Categoria : {data.Tech}</li> */}
                            <li>Categoria : {data.Type}</li>
                            <li>Cupom : PARCEIRANDO</li>
                            <li>Link Afiliação : <a href={data.affiliationLink} target='_blank' rel='noreferrer' style={{ color: '#8c6fff' }}>Cadastrar</a></li>
                        </ul>
                    </div>

                </div>
            </div>
        </ZoomOut>

    )
}

export default PortfolioCard
